"use strict";import{tag as e}from"../custom-tag.js";export function virtualEventIcon({height:a=16,width:t=16,hidden:l=!1,title:r="Virtual event"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        d="M12.004 6.975a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25m0 4.8a2.175 2.175 0 1 1 0-4.35 2.175 2.175 0 0 1 0 4.35m4.114-3.767a.23.23 0 0 0 .245-.049l1.134-1.134h1.707A.826.826 0 0 0 20.03 6V3.6a.826.826 0 0 0-.825-.825h-4.8a.826.826 0 0 0-.825.825V6a.826.826 0 0 0 .825.825h1.575V7.8a.23.23 0 0 0 .139.208m-1.714-1.633A.375.375 0 0 1 14.03 6V3.6a.375.375 0 0 1 .375-.375h4.8a.375.375 0 0 1 .375.375V6a.375.375 0 0 1-.375.375h-1.8a.23.23 0 0 0-.159.066l-.816.816V6.6a.225.225 0 0 0-.225-.225z"
      />
      <path
        fill="currentColor"
        d="M20.404 8.775H15.6v.45h4.804a.375.375 0 0 1 .375.375v8.175h-4.95V15.6a2.03 2.03 0 0 0-2.025-2.025h-3.6A2.027 2.027 0 0 0 8.18 15.6v2.175H3.23V9.6a.375.375 0 0 1 .375-.375H8.4v-.45H3.604a.826.826 0 0 0-.825.825v9.6a.826.826 0 0 0 .825.825h8.175v.75H7.804v.45h8.4v-.45H12.23v-.75h8.175a.826.826 0 0 0 .825-.825V9.6a.826.826 0 0 0-.825-.825M8.63 15.6a1.577 1.577 0 0 1 1.575-1.575h3.6A1.577 1.577 0 0 1 15.38 15.6v2.175H8.63zm12.15 3.6a.376.376 0 0 1-.375.375h-16.8a.375.375 0 0 1-.375-.375v-.975h17.55z"
      />
    </svg>
  `}
//# sourceMappingURL=virtualEvent.js.map
